// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-62496e35] {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  padding-bottom: 1.36rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.container img[data-v-62496e35] {\n    width: 100%;\n    height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
